export default 'search';
